import {
  Box,
  Column,
  Columns,
  IconChevron,
  Stack,
  Text,
} from 'braid-design-system';
import { SlideDown } from 'react-slidedown';

import * as styles from './CustomAccordion.css';

interface Props {
  label: string;
  summary?: string;
  expanded: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: React.ReactElement | null;
  showOnDesktop?: boolean;
}

export const CustomAccordion = ({
  label,
  summary,
  expanded,
  onToggle,
  disabled,
  children,
}: Props) => {
  const isEmpty = children === null;

  return (
    <Box>
      <Stack space="medium">
        <Box
          {...(!disabled && { onClick: onToggle, className: styles.toggle })}
        >
          <Columns space="none" alignY="center">
            <Column>
              <Text
                size="large"
                weight="medium"
                tone={disabled ? 'secondary' : expanded ? 'neutral' : 'link'} // eslint-disable-line
              >
                <span className={isEmpty ? '' : styles.link}>{label}</span>
              </Text>
            </Column>
            {!disabled ? (
              <Column width="content">
                <IconChevron
                  tone="link"
                  size="large"
                  direction={expanded ? 'up' : 'down'}
                />
              </Column>
            ) : null}
          </Columns>
        </Box>
        <Box paddingRight={['none', 'large', 'xxlarge']}>
          <Text tone="secondary">{summary}</Text>
        </Box>
        {expanded ? (
          <SlideDown
            closed={!expanded}
            style={{
              height: 0,
              transitionProperty: 'none',
              transitionDuration: '0.3s',
              transitionTimingFunction: 'ease-in-out',
              overflowY: 'visible',
            }}
          >
            <Box paddingTop="small">{children}</Box>
          </SlideDown>
        ) : null}
      </Stack>
    </Box>
  );
};
